module.exports = __webpack_public_path__ + "img/mechanics.69e1a832.svg";